import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectAddImageSuccess,
  selectTextToImages,
  selectTextToImagesLoading,
  selectTextToImagesSuccess,
} from '../vb/reducer'
import useLightModePreference from '../util/useLightModePreference'
import {
  ADD_IMAGE_SUCCESS_TEXT,
  GENERATE_IMAGE_LOADING_TEXT,
} from './constants'
import infoIcon from './assets/client-info-icon.png'
import closeLightModeIcon from './assets/client-close-icon.png'
import closeDarkModeIcon from './assets/client-close-dark-mode-icon.png'
import {
  selectIsResultCleared,
  selectErrorMessage,
  selectIsNotificationVisible,
} from './reducer'
import { setIsNotificationVisible } from './actions'
import './NotificationMessage.css'
import { useTranslation } from 'react-i18next'

const NotificationMessage = ({ text = '' }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isNotificationVisible = useSelector(selectIsNotificationVisible)
  const textToImagesSuccess = useSelector(selectTextToImagesSuccess)
  const addImageSuccess = useSelector(selectAddImageSuccess)
  const isTextToImagesLoading = useSelector(selectTextToImagesLoading)
  const textToImages = useSelector(selectTextToImages)
  const isResultCleared = useSelector(selectIsResultCleared)
  const isLightMode = useLightModePreference()
  const errorMessage = useSelector(selectErrorMessage)
  const closeIcon = isLightMode ? closeLightModeIcon : closeDarkModeIcon
  const message = addImageSuccess
    ? t(ADD_IMAGE_SUCCESS_TEXT)
    : isTextToImagesLoading
    ? t(GENERATE_IMAGE_LOADING_TEXT)
    : text

  // "Generating image waiting time" notification
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (textToImagesSuccess && !textToImages.length && !isResultCleared) {
        dispatch(setIsNotificationVisible(true))
      }
    }, 10000)

    return () => clearTimeout(timeoutId)
  }, [textToImagesSuccess, textToImages.length, isResultCleared, dispatch])

  // "Save image in client setting" notification
  useEffect(() => {
    let timeoutId

    if (addImageSuccess) {
      dispatch(setIsNotificationVisible(true))

      // Clear any existing timeout for hiding the notification
      clearTimeout(timeoutId)

      // Set a timeout to hide the "save image success" notification after 5 seconds
      timeoutId = setTimeout(() => {
        dispatch(setIsNotificationVisible(false))
      }, 5000)
    }

    return () => clearTimeout(timeoutId)
  }, [addImageSuccess, dispatch])

  // "show support English language notification
  useEffect(() => {
    let timeoutId

    if (text) {
      dispatch(setIsNotificationVisible(true))

      // Clear any existing timeout for hiding the notification
      clearTimeout(timeoutId)

      // Set a timeout to hide the "save image success" notification after 10 seconds
      timeoutId = setTimeout(() => {
        dispatch(setIsNotificationVisible(false))
      }, 10000)
    }

    return () => clearTimeout(timeoutId)
  }, [text, dispatch])

  useEffect(() => {
    if (textToImages.length || errorMessage) {
      dispatch(setIsNotificationVisible(false))
    }
  }, [textToImages.length, errorMessage, dispatch])

  const handleClick = () => {
    dispatch(setIsNotificationVisible(false))
  }

  if (!isNotificationVisible || !message) return null

  return (
    <div className="NotificationMessage" role="alert">
      <div className="NotificationMessage__heading">
        <div className="NotificationMessage__heading-container">
          <img
            className="NotificationMessage__heading-info-icon"
            src={infoIcon}
            alt="info"
          />
          <p className="NotificationMessage__heading-text">{message}</p>
        </div>

        <button
          className="NotificationMessage__heading-close-icon"
          onClick={handleClick}
        >
          <img
            src={closeIcon}
            alt={`${!isNotificationVisible ? 'close' : ''}`}
          />
        </button>
      </div>
    </div>
  )
}

export default NotificationMessage
